// Purchase funnel: basket (Cart.jsx) and checkout (Checkout.jsx).
// Translation of fr/tunnel.js — same keys, same order.
// Tone: English has no tu/vous split, so the French shift is carried by
// register — relaxed and playful in the basket (contractions, « your
// adventure »), plainer and more formal from the checkout onwards.
export default {
  // --- Basket (Cart.jsx) ---
  'tunnel.panier.seoTitre': 'My basket',
  'tunnel.panier.seoDescription':
    'Check your Joyful Reveal basket and pay securely with Stripe. Got a promo code? Enter it again here.',
  'tunnel.panier.titre': '🛒 Your basket',
  'tunnel.panier.sousTitreVide': 'Start an adventure by collecting the puzzle pieces',
  'tunnel.panier.sousTitreUn': 'You’ve got {n} piece in your basket',
  'tunnel.panier.sousTitrePlusieurs': 'You’ve got {n} pieces in your basket',
  'tunnel.panier.retireTitreUn': 'An item has been removed from your basket',
  'tunnel.panier.retireTitrePlusieurs': 'Some items have been removed from your basket',
  'tunnel.panier.retireDetail':
    '{noms} — this pack is no longer on sale. You will find our current packs in the',
  'tunnel.panier.retireDetailLien': 'shop',
  'tunnel.panier.progression': 'Collection in progress',
  'tunnel.panier.videTitre': 'Empty basket',
  'tunnel.panier.videTexte':
    'There’s nothing here... yet! Start your adventure by collecting the puzzle pieces.',
  'tunnel.panier.videCta': '🎯 Back to the adventure',
  'tunnel.panier.langue': 'Language:',
  'tunnel.panier.retirerDuPanier': 'Remove from basket',
  'tunnel.panier.sousTotal': 'Subtotal',
  'tunnel.panier.reduction': 'Discount ({code})',
  'tunnel.panier.retirer': 'Remove',
  'tunnel.panier.livraison': 'Shipping',
  'tunnel.panier.livraisonADeterminer': 'To be confirmed',
  'tunnel.panier.codePromo': 'Promo code',
  'tunnel.panier.appliquer': 'Apply',
  'tunnel.panier.promoAppliquee': 'Code "{code}" applied!',
  'tunnel.panier.total': 'Total',
  'tunnel.panier.offreSpeciale': 'Special collection unlocked! You’re close to the big secret.',
  'tunnel.panier.continuerCollecter': '← Keep collecting',
  'tunnel.panier.procederPaiement': '🎯 Proceed to checkout',

  // --- Checkout (Checkout.jsx) ---
  'tunnel.checkout.seoTitre': 'Payment - Secure checkout',
  'tunnel.checkout.seoDescription':
    'Complete your Joyful Reveal puzzle purchase securely with Stripe. Fast delivery in France and across Europe.',
  'tunnel.checkout.chargement': 'Loading...',
  'tunnel.checkout.erreur': '❌ Error: {message}',
  'tunnel.checkout.etape': 'Step {n} / 3',
  'tunnel.checkout.sansCompte':
    '✅ No need to create an account — your email address is enough to receive the confirmation and the tracking of your parcel.',
  'tunnel.checkout.dejaCompte': 'Already have an account?',
  'tunnel.checkout.dejaCompteLien': 'Log in',
  'tunnel.checkout.dejaCompteFin': 'to find your orders.',
  'tunnel.checkout.etape1Titre': '📍 Delivery address',
  'tunnel.checkout.champNomComplet': 'Full name',
  'tunnel.checkout.champEmail': 'Email',
  'tunnel.checkout.champAdresse': 'Address',
  'tunnel.checkout.champVille': 'Town / City',
  'tunnel.checkout.champCodePostal': 'Postcode',
  'tunnel.checkout.choisirPays': 'Choose a country',
  'tunnel.checkout.paysFR': 'France',
  'tunnel.checkout.paysBE': 'Belgium',
  'tunnel.checkout.paysLU': 'Luxembourg',
  'tunnel.checkout.paysDE': 'Germany',
  'tunnel.checkout.paysES': 'Spain',
  'tunnel.checkout.paysIT': 'Italy',
  'tunnel.checkout.paysNL': 'Netherlands',
  'tunnel.checkout.paysPT': 'Portugal',
  'tunnel.checkout.etape2Titre': '🚚 Delivery method',
  'tunnel.checkout.calculTarifs': 'Calculating rates...',
  'tunnel.checkout.etapeSuivanteRequise': 'Next step required',
  'tunnel.checkout.choisirPointRelaisTexte':
    'Select the pickup point where you would like to collect your order',
  'tunnel.checkout.choisirPointRelaisBouton': '🗺️ CLICK HERE TO CHOOSE YOUR PICKUP POINT',
  'tunnel.checkout.pointRelaisSelectionne': '✓ Pickup point selected',
  'tunnel.checkout.modifier': 'Change',
  // The pickup point picker is a third-party script: it can go missing
  // (network, ad blocker). These messages replace English alert() boxes.
  'tunnel.checkout.selecteurIndisponible':
    'The pickup point map could not load. Reload the page, and if the problem persists, switch off your ad blocker while you place your order.',
  'tunnel.checkout.choisirTransporteurDabord': 'Please choose a delivery method above first.',
  'tunnel.checkout.selecteurErreur':
    'The pickup point map did not respond. Please try again in a moment.',
  // Delivery method shown on every option: Sendcloud returns about ten of
  // them, and the product name does not say where the parcel arrives.
  'tunnel.checkout.modePointRelais': '📍 Pickup point',
  'tunnel.checkout.modeDomicile': '🏠 Home delivery',
  // Only shown when the contribution is real. Plain wording: we say what we
  // do, without apologising for the price or drawing attention to it.
  'tunnel.checkout.participation': '💚 We are covering {montant} € of this route ourselves',
  // True because the rate comes from the carrier, down to the cent: nothing is
  // added on top. Said for every country, without singling one out.
  'tunnel.checkout.portSansMarge':
    'The rate shown is the carrier’s own, down to the cent — we add nothing on top.',
  'tunnel.checkout.livraisonDomicileTexte': '✓ Delivered straight to your address: {adresse}',
  'tunnel.checkout.indispoTitre': '⏳ Delivery to this country is temporarily unavailable',
  'tunnel.checkout.indispoTexte':
    'No carrier is offering us this route at the moment. We are working on opening it — in the meantime you can check the address you entered (postcode and town), choose another delivery country, or write to us: we will find a solution together.',
  'tunnel.checkout.indispoModifierAdresse': '← Change the address',
  'tunnel.checkout.indispoContact': '💬 Contact us',
  'tunnel.checkout.voirPlusOptions': '↓ Show the {n} other carriers',
  'tunnel.checkout.voirMoinsOptions': '↑ Show fewer options',
  'progression.complete': '✨ REVEAL COMPLETE! ✨',
  'progression.restant': '{n} pieces left to discover',
  // Le tunnel de commande compte des ÉTAPES : y afficher « Plus que 23
  // pièces à découvrir » juste au-dessus du bouton de paiement inquiétait
  // l'acheteur au lieu de le rassurer.
  'progression.etapeRestante': "{n} step left before payment",
  'progression.etapesRestantes': "{n} steps left before payment",
  'progression.pretAPayer': "Last step: payment",
  'tunnel.panier.etape': "Your basket",
  'tunnel.checkout.tarifsAttenteLongue':
    'One moment — the connection to the carrier is taking a little longer than usual.',
  'tunnel.checkout.tarifsReprise':
    'The carrier is not answering, we are trying again ({n}/{total})…',
  'tunnel.checkout.tarifsErreurTitre':
    '⚠️ We could not work out the shipping cost',
  'tunnel.checkout.tarifsErreurTexte':
    'We tried three times without success. This is not about your country, but about our link to the carrier. Run the calculation again — if it keeps happening, write to us and we will complete the order with you.',
  'tunnel.checkout.tarifsReessayer': '↻ Try again',
  'tunnel.checkout.etape3Titre': '💳 Payment',
  'tunnel.checkout.redirectionStripe':
    'You are about to be redirected to a secure Stripe payment page.',
  'tunnel.checkout.redirection': 'Redirecting...',
  'tunnel.checkout.procederPaiement': 'Proceed to secure payment →',
  'tunnel.checkout.retour': '← Back',
  'tunnel.checkout.continuer': 'Continue →',
  'tunnel.checkout.recapitulatif': '📦 Summary',
  'tunnel.checkout.recapLivraison': '🚚 Shipping ({nom})',
  'tunnel.checkout.recapReduction': '🏷️ Discount ({code})',
  'tunnel.checkout.total': 'Total:',
  'tunnel.checkout.paiementReussi': 'Payment successful!',
};
